const html = require('choo/html')
const encoder = require('text-encoding')
const { saveAs } = require('file-saver');

const getSamplesFromInput = require('./utility/getSamplesFromInput.js')
const getFilesFromZip = require('./utility/getFilesFromZip.js')
const getZipFile = require('./utility/getZipFile.js')

function isAllowed(file) {
  console.log("file", file)
  return file.type === 'audio/x-wav'
      || file.type === 'audio/wav'
      || file.type === 'audio/mpeg'
      || file.type === 'audio/mp3'
      || file.type === 'audio/mp4'
      || file.type === 'audio/m4a'
      || file.type === 'audio/x-m4a'
}

module.exports = function importExport(state, emitter) {

  // EXPORTING ZIP FILE
  emitter.on('openfilepicker', () => {
    console.log('openfilepicker')
    function importFiles(files) {
      emitter.emit('importfiles', files)
    }
    function importZip(file) {
      emitter.emit('importzip', file)
    }
    function onChange(e) {
      let files = Object.values(e.target.files)
      if (files.length === 1) {
        // Uploading a single file
        const file = files[0]
        if (isAllowed(file)) {
          importFiles(files)
        } else if (file.type === 'application/zip' ||
          file.type === 'application/x-zip-compressed' ||
          file.name.indexOf('.zip') !== -1) {
          importZip(file)
        }
      } else if (files.length > 2) {
        // More than one file, just import the wav files
        let onlyWavFiles = files.filter(
          file => isAllowed(file)
        )
        importFiles(files)
      }

    }
    const input = html`
      <input
        multiple
        type="file"
        onchange=${onChange}
        accept=".wav,.mp3,.zip, .m4a"
        />
    `
    input.click()
  })
  emitter.on('importfiles', (files) => {
    console.log('importfiles')
    getSamplesFromInput(files).then((samples) => {
      samples.forEach(sample => state.samples.unshift(sample))
      emitter.emit('render')
      document.querySelector('#sound-list').scroll({ top: 0 })
    })
  })
  emitter.on('importzip', (file) => {
    console.log('importzip', file)
    getFilesFromZip(file).then((data) => {
      let config = data.find(f => f.name.indexOf('config.json') !== -1)
      const decoder = new encoder.TextDecoder()
      config = JSON.parse(
        decoder.decode(config.buffer)
      )
      config.samples.forEach((sample) => {
        let sampleFile = data.find(
          d => d.name === sample.file
        )
        sample.file = new Tone.Player(sampleFile.buffer).toDestination()
        sample.mySample = true
        state.samples.unshift(sample)
      })
      config.pack.name = file.name.split('.')[0]
      state.packs.push(config.pack)
      state.sharedPack = config.pack
      emitter.emit('loadpack', config.pack)
    })
    .catch(console.log)
  })
  emitter.on('exportsamplepack', () => {
    console.log('exportsamplepack')
    getZipFile(state).then(({content, config}) => {
      saveAs(content, `${config.pack.name}.zip`);
    })
  })
}
